import { supabase } from './supabase';

export interface ReviewQueueHandlers {
  /** A draft was inserted or changed - refetch. */
  onDraftChange: () => void;
  /** New raw content arrived. */
  onNewItem?: () => void;
}

/**
 * Subscribe the review queue to database changes.
 *
 * The acceptance criterion for P1.5 is "a new draft appears in the browser
 * without a refresh". Realtime delivers that; the handler is deliberately dumb
 * (it just refetches) because a partial row from a realtime payload is not the
 * same thing as the joined view the reviewer needs.
 */
export function subscribeToReviewQueue(handlers: ReviewQueueHandlers): () => void {
  const channel = supabase
    .channel('review-queue')
    .on('postgres_changes', { event: '*', schema: 'nestmatch', table: 'drafts' }, () => {
      handlers.onDraftChange();
    })
    .on('postgres_changes', { event: 'INSERT', schema: 'nestmatch', table: 'items' }, () => {
      handlers.onNewItem?.();
    })
    .subscribe();

  return () => {
    void supabase.removeChannel(channel);
  };
}
